module.exports = __webpack_public_path__ + "static/media/Mobile_Data_ETHICAL_HACKING_METOLOGIA_DE_PENTEST.72bf2ad7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/banners/courses/ethical hacking/Mobile_Data_ETHICAL_HACKING_METOLOGIA_DE_PENTEST.png
// module id = 78
// module chunks = 0